<script>
	const img = "/img/error.png";
	const home = location.protocol + "//" + location.host;
	const imgPath = home + img;

	export let error;
	export let alt = "Whoops error! Refresh or try again later.";

	console.log("ERROR! ", error);
</script>

<section>
	<div class="image-container">
		<a href={home}><img src={imgPath} {alt} /></a>
	</div>
</section>

<style>
	@media (max-width: 700px) {
		section {
			/* padding-left: 8%; */
			/* padding-right: 8%; */
			padding: 0%;
		}
		.image-container {
			margin: 5px !important;
		}
	}
	.image-container {
		margin: 55px;
		text-align: center;
	}
	img {
		max-width: 55%;
		max-height: 55%;
	}
</style>
